/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React, { FC } from 'react';

import styles from './LandingPageTip.module.scss';

const browsers = [
    {
        name: 'Chrome',
        link:
            'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en',
        icon: 'chrome-icon.svg',
    },
    {
        name: 'Edge',
        link:
            'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US',
        icon: 'edge-icon.svg',
    },
    {
        name: 'Firefox',
        link: 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/',
        icon: 'firefox-icon.svg',
    },
    {
        name: 'Brave',
        link:
            'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en',
        icon: 'brave-icon.svg',
    },
];

const platforms = [
    {
        name: 'Android',
        link:
            'https://play.google.com/store/apps/details?id=io.metamask&hl=en_US&ref=producthunt&_branch_match_id=955784374316405623',
        icon: 'android-icon.svg',
    },
    {
        name: 'iOS',
        link:
            'https://apps.apple.com/us/app/metamask/id1438144202?_branch_match_id=955784374316405623',
        icon: 'apple-icon.svg',
    },
];

export const LandingPageTip: FC = () => {
    const iconEl = ({ name, link, icon }: { name: string; link: string; icon: string }) => (
        <span key={name}>
            <a className={styles.icon} href={link} target="_blank" rel="noreferrer">
                <img src={`assets/img/${icon}`} alt={name} />
            </a>
        </span>
    );

    return (
        <div className={styles.wrapper}>
            <div className={styles.pointer}></div>
            <div className={styles.note}>Make sure you have MetaMask installed.</div>
            <div className={styles.iconsWrapper}>
                <div>
                    <div>Browsers</div>
                    {browsers.map(iconEl)}
                </div>
                <div>
                    <div>Platforms</div>
                    {platforms.map(iconEl)}
                </div>
            </div>
        </div>
    );
};
